import Vue from 'vue';
import { format } from 'timeago.js';

Vue.filter('time-ago', (value: Date | null | undefined) => {
  if (!value) return '';

  return format(value);
});
